// Generated by ReScript, PLEASE EDIT WITH CARE


let formatShort = (function(iso) {
    try {
      return new Date(iso).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    } catch (e) {
      return iso;
    }
  });

let formatLong = (function(iso) {
    try {
      return new Date(iso).toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    } catch (e) {
      return iso;
    }
  });

export {
  formatShort,
  formatLong,
}
/* No side effect */
